// React
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Grid } from "@mui/material";
import styled from "styled-components";
import CurrencyExchangeTwoToneIcon from "@mui/icons-material/CurrencyExchangeTwoTone";
import DiscountTwoToneIcon from "@mui/icons-material/DiscountTwoTone";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import BusinessTwoToneIcon from "@mui/icons-material/BusinessTwoTone";
import PersonOutlineTwoToneIcon from "@mui/icons-material/PersonOutlineTwoTone";
import BadgeTwoToneIcon from "@mui/icons-material/BadgeTwoTone";
import RoomTwoToneIcon from "@mui/icons-material/RoomTwoTone";
import { useAuth } from "../../services/auth";
import theme from "../../theme";

const ReportItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  height: fit-content;
  border-radius: 20px;
  width: 350px;
  border: 1px solid ${theme.color.grayText};
  padding: 0 10px;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  &:hover {
    background-color: ${theme.color.gray50};
    text-decoration: underline;
    color: ${theme.color.grayText};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15); /* Enhanced shadow on hover */
    transform: scale(1.1);
  }
`;

const IconWrapper = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ReportsList = () => {
  let navigate = useNavigate();
  const { role } = useAuth();

  let reportAllPermission = [
    {
      name: "Transactions Report",
      icon: (
        <CurrencyExchangeTwoToneIcon
          fontSize="small"
          color="action"
        ></CurrencyExchangeTwoToneIcon>
      ),
      route: "Transactions",
    },
    {
      name: "Transactions By Service",
      icon: (
        <CurrencyExchangeTwoToneIcon
          fontSize="small"
          color="action"
        ></CurrencyExchangeTwoToneIcon>
      ),
      route: "TransactionsByService",
    },
    {
      name: "Transactions Service & Payment Type",
      icon: (
        <CurrencyExchangeTwoToneIcon
          fontSize="small"
          color="action"
        ></CurrencyExchangeTwoToneIcon>
      ),
      route: "TransactionsServicePayment",
    },
    {
      name: "Void Transactions Report",
      icon: (
        <CurrencyExchangeTwoToneIcon
          fontSize="small"
          color="action"
        ></CurrencyExchangeTwoToneIcon>
      ),
      route: "Voids",
    },
    {
      name: "Live Paid Transactions Report",
      icon: (
        <CurrencyExchangeTwoToneIcon
          fontSize="small"
          color="action"
        ></CurrencyExchangeTwoToneIcon>
      ),
      route: "Live",
    },
    {
      name: "Transactions CheckedOut Report",
      icon: (
        <CurrencyExchangeTwoToneIcon
          fontSize="small"
          color="action"
        ></CurrencyExchangeTwoToneIcon>
      ),
      route: "TransactionsCheckedOut",
    },
    {
      name: "Shift Report",
      icon: (
        <DiscountTwoToneIcon
          fontSize="small"
          color="action"
        ></DiscountTwoToneIcon>
      ),
      route: "Shift",
    },
  ];
  let reports = [
    {
      name: "Sales End Shift Report",
      icon: (
        <DiscountTwoToneIcon
          fontSize="small"
          color="action"
        ></DiscountTwoToneIcon>
      ),
      route: "SalesEndShift",
    },
    {
      name: "Employees Roles By Site Report",
      icon: (
        <PersonOutlineTwoToneIcon
          fontSize="small"
          color="action"
        ></PersonOutlineTwoToneIcon>
      ),
      route: "EmployeesRoles",
    },
    {
      name: "Daily Sales Payroll Report",
      icon: (
        <BadgeTwoToneIcon fontSize="small" color="action"></BadgeTwoToneIcon>
      ),
      route: "DailySales",
    },
    {
      name: "Daily Sales By Shift",
      icon: (
        <DiscountTwoToneIcon
          fontSize="small"
          color="action"
        ></DiscountTwoToneIcon>
      ),
      route: "DailySalesByShift",
    },
    {
      name: "Daily Sales By Location",
      icon: <RoomTwoToneIcon fontSize="small" color="action"></RoomTwoToneIcon>,
      route: "DailySalesLocation",
    },
    {
      name: "Monthly Sales By Location",
      icon: <RoomTwoToneIcon fontSize="small" color="action"></RoomTwoToneIcon>,
      route: "MonthlySalesLocation",
    },
    {
      name: "Yearly Sales By Location",
      icon: <RoomTwoToneIcon fontSize="small" color="action"></RoomTwoToneIcon>,
      route: "YearlySalesLocation",
    },
    {
      name: "Highest Payroll Report",
      icon: (
        <MonetizationOnOutlinedIcon
          fontSize="small"
          color="action"
        ></MonetizationOnOutlinedIcon>
      ),
      route: "HighestPayroll",
    },

    {
      name: "Sites By Sales Report",
      icon: (
        <BusinessTwoToneIcon
          fontSize="small"
          color="action"
        ></BusinessTwoToneIcon>
      ),
      route: "SiteBySales",
    },
    {
      name: "Sites By Tickets Report",
      icon: (
        <BusinessTwoToneIcon
          fontSize="small"
          color="action"
        ></BusinessTwoToneIcon>
      ),
      route: "SitesByTickets",
    },
    {
      name: "Sites Zones Services",
      icon: (
        <BusinessTwoToneIcon
          fontSize="small"
          color="action"
        ></BusinessTwoToneIcon>
      ),
      route: "SitesZonesServices",
    },
    {
      name: "Search By Services",
      icon: (
        <BusinessTwoToneIcon
          fontSize="small"
          color="action"
        ></BusinessTwoToneIcon>
      ),
      route: "SearchByServices",
    },
  ];

  return (
    <>
      <Typography variant="Poster" component="h4">
        Reports
      </Typography>

      <Box sx={{ flexGrow: 1, mt: 2 }}>
        <Grid
          container
          spacing={{ xs: 2, md: 4 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {reportAllPermission.map((report, index) => {
            if (
              report.name === "Live Paid Transactions Report" &&
              role === "SubCompany"
            ) {
              return null;
            }

            return (
              <Grid item xs={2} sm={3} md={4} key={index}>
                <ReportItem onClick={() => navigate(report.route)}>
                  <Typography sx={{ textAlign: "left", fontSize: "14px" }}>
                    {report.name}
                  </Typography>
                  <IconWrapper>{report.icon}</IconWrapper>
                </ReportItem>
              </Grid>
            );
          })}
          {(role === "Admin" || role === "Company") &&
            reports.map((report, index) => (
              <Grid item xs={2} sm={3} md={4} key={index}>
                <ReportItem onClick={() => navigate(report.route)}>
                  <Typography sx={{ textAlign: "left", fontSize: "14px" }}>
                    {report.name}
                  </Typography>
                  <IconWrapper>{report.icon}</IconWrapper>
                </ReportItem>
              </Grid>
            ))}
        </Grid>
      </Box>
    </>
  );
};

export default React.memo(ReportsList);
